import { forwardRef, type Ref, type SVGProps } from "react";
const IconMapOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 3.88a2.2 2.2 0 0 0-.7.13l-6 1.9a1 1 0 0 1-.58 0l-9.47-2.84a1.2 1.2 0 0 0-.5 0L3.51 4.62A2 2 0 0 0 2 6.56v18.88a2 2 0 0 0 2 2 2 2 0 0 0 .49-.06l6.26-1.33a1.2 1.2 0 0 1 .49 0l9.46 2.84a1 1 0 0 0 .6 0l7.4-2.41a2 2 0 0 0 1.3-1.87V5.89a2 2 0 0 0-2-2.01M12 5.3l8 2.4v19l-8-2.4ZM4 25.44V6.56l6-1.34v19Zm24-.83-6 2.05V7.7l6-1.81Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMapOutlineSVG);
ForwardRef.displayName = "IconMapOutline";
export { ForwardRef as IconMapOutline };
